export enum EstadosComprobanteElectronicoType{
    BOLETA= "boleta", //tiene emisión de boleta de venta
    FACTURA='factura', // cuando se emitio factura
    NINGUNO='ninguno', // cuando no se emitio nada
    POR_ACTUALIZAR='por_actualizar',// cuando se solicito una anulacion y sunat demora la actualizacion
    ACTUALIZADO='actualizado'


}